import { ImageManager } from './ImageManager';

const defaultImagesMap = {
  IMAGE_01:
    'https://placehold.co/1920x1080/0066cc/ffffff?text=Image+Placeholder',
  IMAGE_02:
    'https://placehold.co/1920x1080/4a90e2/ffffff?text=Image+Placeholder',
  IMAGE_03:
    'https://placehold.co/1920x1080/50c878/ffffff?text=Image+Placeholder',
  IMAGE_04:
    'https://placehold.co/1920x1080/f39c12/ffffff?text=Image+Placeholder',
  IMAGE_59:
    'https://placehold.co/1920x1080/9b59b6/ffffff?text=Image+Placeholder',
  IMAGE_09:
    'https://placehold.co/1920x1080/e74c3c/ffffff?text=Image+Placeholder',
  IMAGE_10:
    'https://placehold.co/1920x1080/1abc9c/ffffff?text=Image+Placeholder',
  IMAGE_15:
    'https://placehold.co/1920x1080/34495e/ffffff?text=Image+Placeholder',
  IMAGE_16:
    'https://placehold.co/1920x1080/e67e22/ffffff?text=Image+Placeholder',
  IMAGE_17:
    'https://placehold.co/1920x1080/3498db/ffffff?text=Image+Placeholder',
  IMAGE_31:
    'https://images.pexels.com/photos/3987020/pexels-photo-3987020.jpeg?auto=compress&cs=tinysrgb&w=1920',
};


const listingsPlaceholderImage = {
  placeholder_1: 'https://s3.us-west-1.wasabisys.com/bay/client/listing-building-blue.jpg',
  placeholder_2: 'https://s3.us-west-1.wasabisys.com/bay/client/listing-townhouse-pink.jpg',
  placeholder_3: 'https://s3.us-west-1.wasabisys.com/bay/client/listing-villa-green.jpg',
  placeholder_4: 'https://s3.us-west-1.wasabisys.com/bay/client/listing-house-purple.jpg',
  placeholder_5: 'https://s3.us-west-1.wasabisys.com/bay/client/listing-apartment-pink.jpg',
  placeholder_6: 'https://s3.us-west-1.wasabisys.com/bay/client/listing-land-sale-blue.jpg',
  placeholder_7: 'https://s3.us-west-1.wasabisys.com/bay/client/listing-building-purple.jpg',
  placeholder_8: 'https://s3.us-west-1.wasabisys.com/bay/client/listing-house-green.jpg',
};

ImageManager.add(defaultImagesMap);
export function getImg(name: keyof typeof defaultImagesMap) {
  return ImageManager.get(name);
}

export function getListingPlaceholderImage(
  name: keyof typeof listingsPlaceholderImage | string,
): string {
  if (
    Object.prototype.hasOwnProperty.call(
      listingsPlaceholderImage,
      name,
    )
  ) {
    return listingsPlaceholderImage[
      name as keyof typeof listingsPlaceholderImage
    ];
  }

  return listingsPlaceholderImage.placeholder_1;
}
